<template>
  <div>
    <a-table v-if="relationTestPlans.length > 0" :pagination="false" size="small" :columns="selectedColumns" row-key="id" :data-source="relationTestPlans" class="plan_table">
      <span slot="customId" slot-scope="text, record"> {{ record.key }}</span>
      <span slot="customTitle" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.name">
          <a class="issue_title" :href="link(record)" target="_blank">{{ record.name }}</a>
        </a-tooltip>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-badge :status="testPlanStatus[record.status].status" :text="testPlanStatus[record.status].label" />
      </span>
      <span slot="progress" slot-scope="text, record">
        <a-progress :percent="record.progress" size="small" style="width: 130px" />
      </span>
      <span slot="action" slot-scope="text, record, index">
        <a @click="onRemove(index)">移除</a>
      </span>
    </a-table>
    <a-button icon="search" type="dashed" class="search-button" @click="onSelect"> 选择测试计划</a-button>
    <a-modal v-model="visible" :width="960" title="选择测试计划" @ok="handleOk" @cancel="close">
      <a-input-search v-model="searchKeyword" placeholder="ID或标题搜索" class="requirement_search" allow-clear enter-button @search="onSearch" />
      <a-table :loading="loading" :expand-icon-column-index="2" :pagination="pagination" size="small" :columns="columns" row-key="id" :row-selection="rowSelection" :data-source="planData" @change="handleTableChange">
        <span slot="customId" slot-scope="text, record"> {{ record.key }}</span>
        <span slot="customTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a class="issue_title" :href="link(record)" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="testPlanStatus[record.status].status" :text="testPlanStatus[record.status].label" />
        </span>
        <span slot="progress" slot-scope="text, record">
          <a-progress :percent="record.progress" size="small" style="width: 130px" />
        </span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { testPlanList } from '@/api/project/testPlan';
import { testPlanTypes, testPlanStatus } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '测试进度',
    width: 150,
    scopedSlots: { customRender: 'progress' }
  }
];
const selectedColumns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '测试进度',
    width: 150,
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    planList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      testPlanTypes,
      testPlanStatus,
      selectedColumns,
      loading: false,
      visible: false,
      testPlans: {},
      planData: [],
      selected: [],
      selectedRowKeys: [],
      searchKeyword: '',
      planIds: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      releaseId: parseInt(this.$route.query.releaseId) || null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  computed: {
    relationTestPlans() {
      return this.selected.map(key => {
        return this.testPlans[key];
      });
    },
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:testplan:detail',
          query: { planId: record.id }
        }).href;
      };
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: record => ({
          props: {
            disabled: record.disabled
          }
        })
      };
    }
  },
  watch: {
    selected() {
      this.$emit('change', this.selected);
    },
    planList: {
      immediate: true,
      handler(val) {
        this.planIds = val.map(plan => plan.id);
        this.getTestPlansList();
      }
    }
  },
  methods: {
    getTestPlansList() {
      this.loading = true;
      testPlanList({
        project_id: this.projectId,
        title: this.searchKeyword,
        ids: this.planIds,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.planData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getTestPlansList();
    },

    onSearch() {
      this.pagination.current = 1;
      this.getTestPlansList();
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      selectedRows.forEach(item => {
        this.$set(this.testPlans, item.id, { id: item.id, key: item.key, name: item.name, status: item.status });
      });
    },

    onSelect() {
      this.visible = true;
      this.selectedRowKeys = [...this.selected];
      // this.getTestPlansList();
    },

    onRemove(index) {
      this.selected.splice(index, 1);
    },

    handleOk() {
      this.selected = [...this.selectedRowKeys];
      this.close();
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:project:issue:detail',
        query: { issueId: record.id }
      });
    },

    close() {
      this.visible = false;
      this.selectedRowKeys = [];
    }
  }
};
</script>
<style lang="less" scoped>
.search-button {
  width: 100%;
}

.issue_title:hover {
  cursor: pointer;
  color: #1890ff;
}

.issue_title {
  color: rgba(0, 0, 0, 0.65);
}

.requirement_search {
  margin: 8px 0;
}
</style>
